export function calculatePpd(total, censusAmount, amountDaysInBudget) {
  if (!(censusAmount > 0 && amountDaysInBudget > 0) || total === null) return null;
  return total / censusAmount / amountDaysInBudget;
}
